var $d0ef36edb6b10634$exports = {};
$d0ef36edb6b10634$exports = {
    "collectionLabel": `N\xe1vrhy`
};


export {$d0ef36edb6b10634$exports as default};
//# sourceMappingURL=cs-CZ.module.js.map
